/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ThumbsDownIcon = /*#__PURE__*/ createSvgIcon(
  'ThumbsDownIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M2.5 13c-.375 0-.719-.156-1.031-.469C1.156 12.22 1 11.875 1 11.5v-1.188c0-.11.01-.215.031-.312.021-.097.052-.188.094-.27l2.48-5.813c.124-.292.357-.521.697-.688.34-.167.67-.25.99-.25L14.5 3v10l-4.875 4.875a1.832 1.832 0 01-.906.51c-.34.077-.646.039-.917-.114-.27-.153-.444-.4-.52-.74a2.627 2.627 0 01.01-1.114L8 13H2.5zm10.5-.625V4.5H5l-2.5 5.813V11.5h7.333l-1.02 5.042L13 12.375zM17.5 3c.43 0 .788.147 1.073.44.285.294.427.647.427 1.06v7c0 .412-.142.766-.427 1.06-.285.293-.642.44-1.073.44h-3v-1.5h3v-7h-3V3h3z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ThumbsDownIcon;
